export default __webpack_public_path__ + "static/media/successfull.2ba4b42d.png";